import React from 'react';
import { Record } from 'immutable';

// Types
import { WorkspaceMeetingMode } from 'Shared/types/WorkspaceMeetingMode.type';

// Selectors
import * as MeetingItemSelectors from 'Shared/selectors/MeetingItems.selectors';
import { useSelector } from 'react-redux';

// Helpers
import MeetingItmeHelper from 'Shared/model_helpers/MeetingItem.helper';
import WorkspaceMeetingModeHelper from 'Shared/model_helpers/WorkspaceMeetingMode.helper';

// Components
import ItemDoesntExistError from 'Shared/components/ItemDoesntExistError/ItemDoesntExistError';
import { WpContainer, WpContainerBody } from 'Wpds/components/container';

type Props = {
  workspaceId: string;
  meetingModeSession: Record<WorkspaceMeetingMode>;
  meetingItemOrderedKeys: Array<string>;
  handleNavigateToItem: Function;
};

const MissingTopicPanel = ({
  workspaceId,
  meetingModeSession,
  handleNavigateToItem,
  meetingItemOrderedKeys,
}: Props) => {
  const baseClassName = 'MissingTopicPanel';

  const seenWorkspaceItemIds = WorkspaceMeetingModeHelper.getSeenWorkspaceItemIdsInNavigationalOrder(
    meetingModeSession
  );
  const seenMeetingItems = useSelector(state =>
    MeetingItemSelectors.getDiscussionTopicsByIdsAndWorkspace(state, {
      worksapceUuid: workspaceId,
      meetingItemIds: seenWorkspaceItemIds.toJS(),
    })
  );

  const lastSeenItem = seenWorkspaceItemIds
    .map(id => seenMeetingItems.find(mi => MeetingItmeHelper.getId(mi) === id))
    .filter(x => x)
    .first();

  const lastSeenItemUuid = MeetingItmeHelper.getUuid(lastSeenItem);

  const handleContinueClick = () => {
    if (seenWorkspaceItemIds.size === 0) {
      // We have not seen any items yet, most likly item was
      // first in the list, and then deleted or moved.
      // we can safely navigation to the first agenda item
      handleNavigateToItem(meetingItemOrderedKeys[0]);
    } else if (
      lastSeenItem &&
      meetingItemOrderedKeys.indexOf(lastSeenItemUuid) >= 0 &&
      meetingItemOrderedKeys.indexOf(lastSeenItemUuid) + 1 < meetingItemOrderedKeys.length
    ) {
      // if the lastSeenItem is in the list, but not the last item,
      // we should be able to safely navigate to the next item
      handleNavigateToItem(meetingItemOrderedKeys[meetingItemOrderedKeys.indexOf(lastSeenItemUuid) + 1]);
    } else if (
      lastSeenItem &&
      meetingItemOrderedKeys.indexOf(lastSeenItemUuid) >= 0 &&
      meetingItemOrderedKeys.indexOf(lastSeenItemUuid) + 1 === meetingItemOrderedKeys.length
    ) {
      // if lastSeenItem is the last one in the agenda list,
      // navigate to the wrapup screen
      handleNavigateToItem('wrapup');
    } else {
      // we're unsure - just navigate to start of agenda
      handleNavigateToItem(meetingItemOrderedKeys[0]);
    }
  };

  return (
    <WpContainer className={baseClassName}>
      <WpContainerBody>
        <div className={`${baseClassName}__body`}>
          <ItemDoesntExistError
            title="Can't find this discussion topic."
            description="This discussion topic appears to have been moved or deleted."
            buttonLabel="Continue"
            buttonCallback={handleContinueClick}
          />
        </div>
      </WpContainerBody>
    </WpContainer>
  );
};

export default MissingTopicPanel;
